/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RouteOrder } from './routeOrder';
import { RouteOrderAck } from './routeOrderAck';

export interface CleanablePairRouteOrderRouteOrderAck {
  elementA?: RouteOrder;
  elementB?: RouteOrderAck;
}
